<template>
  <div>
    <!-- Table Container Card -->
    <b-card id="page-evolution" no-body class="mb-0 p-2">
      <b-card-header class="pl-0 pr-0">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >
        <b-button variant="primary" @click="onCreate">
          <feather-icon icon="PlusIcon" class="mr-25" />
          <span class="text-nowrap">{{ $t(label("register")) }}</span>
        </b-button>
      </b-card-header>
      <Filterss
        :fields="fildsToFilters"
        :model="model"
        @filter-applied="applyFilters"
        @filter-reset="resetFilters"
      />
      <!-- table -->
      <b-table
        id="evolution-table"
        responsive
        :head-variant="headVariant"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :per-page="perPage"
        :busy="loading"
        :items="items"
        :fields="fields"
      >
        <!-- A custom formatted header cell for field 'name' -->
        <template #head()="data">
          <span class="text-black">{{
            $t(labelHeader(data.label.toLowerCase()))
          }}</span>
        </template>

        <!-- <template #cell(guid)="data">
            <b-badge
              pill
              :variant="'light-success'"
              @click="info(data.value)"
            >
              <feather-icon class="text-success" size="18" icon="KeyIcon"/>
            </b-badge>
          </template> -->

        <template #cell(actions)="data">
          <feather-icon
            class="text-success mr-25"
            size="18"
            icon="FileTextIcon"
            @click="onShow(data.item.id)"
          />
          <!-- <span class="align-middle ml-50 text-primary"> {{ $t('show') }}</span> -->

          <feather-icon
            class="text-primary mr-25"
            size="18"
            icon="EditIcon"
            @click="onEdit(data.item.id)"
          />
          <!-- <span class="align-middle ml-50 text-warning" > {{ $t('edit') }}</span> -->

          <feather-icon
            class="text-danger"
            size="18"
            icon="Trash2Icon"
            @click="onDelete(data.item.id)"
          />
          <!-- <span class="align-middle ml-50 text-danger"> {{ $t('delete') }}</span> -->
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle ml-50"></b-spinner>
            <strong>{{ $t("loading") }}...</strong>
          </div>
        </template>
      </b-table>

      <!-- pagination -->
      <div class="mx-2">
        <b-row>
          <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="mb-2">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">{{
                $t("perPage")
              }}</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                @change="handlePerPageChange"
                class="w-50"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            sm="12"
            md="10"
            lg="10"
            xl="10"
            class="d-flex align-items-center justify-content-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
              @change="handlePageChange"
              first-number
              last-number
            >
              <template #prev-text>
                <feather-icon size="18" icon="ChevronLeftIcon" />
              </template>
              <template #next-text>
                <feather-icon size="18" icon="ChevronRightIcon" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BAvatar,
  BFormGroup,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import { allInstances, deleteInstance } from "@/@core/api/request";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

import Filterss from "../components/filters/Filterss.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    BAvatar,
    Filterss,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    model: "evolutionInstances",
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    headVariant: "light",
    items: [],
    fields: [
      { label: "company", key: "nameCompany", sortable: true },
      { label: "name", key: "name", sortable: true },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        title: "name",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
    companyGuid: null,
  }),
  computed: {
    guidCompany() {
      return this.$store.state.appConfig.activeCompanyGuid;
    },
  },

  watch: {
    // "$store.state.appConfig.activeCompanyGuid"(guid) {
    //   this.companyGuid = guid;
    // },
    // guidCompany: {
    //   handler(newValue, oldValue) {
    //     console.log("companyGuid cambió de:", oldValue, "a:", newValue);
    //     if (this.companyGuid !== null && this.companyGuid !== "") {
    //       this.loadAllInstancesEvolution();
    //     }
    //   },
    //   immediate: true, // Se ejecuta inmediatamente al montar el componente
    // },
  },
  created() {},

  async mounted() {
    // this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadAllInstancesEvolution();
  },
  methods: {
    label(field) {
      return `pages.evolutionInstances.table.${field}`;
    },

    labelHeader(field) {
      return `pages.evolutionInstances.table.tableHeader.${field}`;
    },

    chargeParams() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      // if (this.companyGuid !== null)
      //   arrParams.push(`guidCompany,${this.companyGuid}`);

      return getParams(arrParams);
    },

    chargeParamsWithFilters(name) {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      // if (this.companyGuid !== null)
      //   arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`name,${name}`);
      return getParams(arrParams);
    },

    loadAllInstancesEvolution() {
      const param = this.chargeParams();
      this.loading = !this.loading;
      allInstances(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    loadInstancesEvolutionFilter(name) {
      const param = this.chargeParamsWithFilters(name);
      this.loading = !this.loading;
      allInstances(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          if (resp.data == null) {
            this.alertToast(
              "danger",
              `Error`,
              `No se encontraron coincidencias`,
            );
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.loadAllInstancesEvolution();
    },

    handlePerPageChange() {
      this.loadAllInstancesEvolution();
    },

    applyFilters(filters) {
      this.appliedFilters = filters;

      this.loadInstancesEvolutionFilter(filters.name);
    },
    resetFilters() {
      this.appliedFilters = {};

      this.loadAllInstancesEvolution();
    },

    onCreate() {
      this.$router.push({
        name: "evolutionIntancesCreate",
        params: {
          option: 1, // option 1 to create
        },
      });
    },

    onShow(guid) {
      this.$router.push({
        name: "evolutionIntancesEdit",
        params: {
          option: 2, // option 2 to show
          guid: guid,
        },
      });
    },

    onEdit(guid) {
      this.$router.push({
        name: "evolutionIntancesEdit",
        params: {
          option: 3, // option 3 to edit
          guid: guid,
        },
      });
    },

    onDelete(instanceId) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteInstance(instanceId)
            .then(() => {
              stopLoading();
              this.$swal({
                icon: "success",
                title: this.$t("Deleted"),
                text: this.$t("beenDeleted"),
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.loadAllInstancesEvolution();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", `Alerta codigo`, error.message);
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    onInfo() {},

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "../../../public/loader.css";
</style>
